class userPayAgreementsController {
  constructor(UsersService, NotificationService, $scope) {
    'ngInject';
    this.usersService = UsersService;
    this.notificationService = NotificationService;
    this.$scope = $scope;
    this.isLoading = false;
  }
 
  $onInit() {
    var ctr = this;
    this.confirmDeleteDialogOptions = {
      title: 'Confirm Delete',
      visible: false,
      closable: true,
      modal: true,
      buttonLayout: 'normal',
      messages: { close: '' },
      actions: [
        { text: 'No' },
        {
          text: 'Yes',
          primary: true,
          action: () => ctr._doDelete()
        }
      ]
    };
    this.gridOptions = {
      dataSource: [],
      sortable: true,
      pageable: false,
      scrollable: false,
      resizable: true,
      noRecords: { template: 'No pay agreements found.' },
      columns: [
        { field: 'payAgreementId', title: 'ID' },
        { field: 'dateCreatedUtc', title: 'Date Created', template: `#= dateCreatedUtc ? kendo.toString(new Date(dateCreatedUtc), 'dd-MM-yyyy HH:mm') : '-' #` },
        { field: 'dateModifiedUtc', title: 'Date Modified', template: `#= dateModifiedUtc ? kendo.toString(new Date(dateModifiedUtc), 'dd-MM-yyyy HH:mm') : '-' #` },
        { field: 'isActive', title: 'Is Active', template: `#= isActive ? 'Yes' : 'No' #` },
        { field: 'parentJugglerID', title: 'Parent Juggler ID' },
        { field: 'payAgreementStatus', title: 'Status' },
        { field: 'payPayer', title: 'Pay Payer' },
        {
          title: 'Delete',
          width: '80px',
          command: [{
            text: ' ',
            iconClass: 'fa fa-trash',
            click: function(e) {
              e.preventDefault();
              var tr = $(e.currentTarget).closest('tr');
              var dataItem = this.dataItem(tr);
              ctr._pendingDeleteId = dataItem.payAgreementId;
              ctr.confirmDeleteDialog.open();
            }
          }]
        }
      ]
    };
    this._loadAgreements();
  }
 
  _doDelete() {
    this.usersService.resetPayto(
      this.userId,
      this._pendingDeleteId,
      () => {
        this.notificationService.success('Pay agreement deleted.');
        this._loadAgreements();
      },
      () => this.notificationService.error('Failed to delete pay agreement.')
    );
  }
 
  _loadAgreements() {
    this.isLoading = true;
    this.usersService.getPayAgreements(
      this.userId,
      (response) => {
        this.isLoading = false;
        var grid = $('#pay-agreements-grid').data('kendoGrid');
        if (grid) {
          grid.setDataSource(new kendo.data.DataSource({ data: response.data }));
        }
        this.$scope.$apply();
      },
      () => {
        this.isLoading = false;
        this.notificationService.error('Failed to load pay agreements.');
        this.$scope.$apply();
      }
    );
  }
}
 
export default userPayAgreementsController;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-pay-agreements/user-pay-agreements.controller.js
 **/